import { StyledPortalPage } from "./PortalPageStyles";
import Layout from "../../components/layout/Layout";
import { Themed } from "../../context/ThemeContext";
import { useLanguageContext } from "../../context/LanguageContext";
import EVAApiHelper from "../../helpers/EVAApiHelper";

function PortalPageView({ visitor, flowPlayer, finished, submitError }) {
  const { translate } = useLanguageContext();

  /**
   * This method will return the content of the portal page
   * @returns {JSX.Element}
   */
  function renderContent() {
    if (finished) {
      return <p>{translate("eva.frontoffice.portal.messages.completed")}</p>;
    }

    if (submitError) {
      return (
        <>
          <h2>{translate("eva.frontoffice.portal.messages.save_failed")}</h2>
          <p>
            {EVAApiHelper.getResponseError("message", submitError, true) ||
              translate("eva.frontoffice.portal.messages.save_failed_retry")}
          </p>
        </>
      );
    }

    return flowPlayer.renderStep();
  }

  return (
    <Themed frontoffice={true}>
      <StyledPortalPage>
        <Layout
          layoutData={visitor?.visitor_type?.portal_layout}
          content={renderContent()}
        />
      </StyledPortalPage>
    </Themed>
  );
}

export default PortalPageView;
